import $ from 'jquery';
import _ from 'underscore';
import {saveAdress, changeAdress, deleteAdress} from '../api/api';
import isViewport from '../../scripts/util/window/isViewport';
import {sm} from '../../scripts/util/window/isViewport';
import '../../scripts/util/form/serializeObject';

export default class MyAdress {
	constructor() {
		this.selectors = {
			page: '.js-my-adress-page',
			form: '.js-my-adress-form',
			controls: {
				change: '.js-adress-change',
				delete: '.js-adress-delete'
			},
			adresses: '.js-my-adresses',
			adress: '.js-adress',
			tmpl: '.js-my-adress-tmpl',
			submit: '.js-form-submit',
			slideToggle: {
				el: '.js-slide-el',
				wrapper: '.js-slide-wrapper'
			}
		};

		this.tmplSyntax = {
			evaluate: /\{\{(.+?)\}\}/g,
			interpolate: /\{\{=(.+?)\}\}/g,
			escape: /\{\{-(.+?)\}\}/g
		};

		this.state = {
			adress: {
				change: 'adress_state_change'
			},
			slideToggle: {
				open: 'slide-toggle_state_open'
			},
			hidden: 'hidden',
			visible: 'visible'
		};

		this.validateInfo = {
			city: {
				data: {
					'msg-target': 'siblings/.field__error',
					'invalid-value-msg': 'В поле введены некорректные символы',
					'empty-value-msg': 'Введите город',
					'data-input-pattern': '[a-zа-яёії \-]',
					'input-pattern-flags': 'i',
					trim: true
				},
				pattern: '^[a-zA-Zа-яА-Яёії]+[a-zа-яёії \-]*[a-zA-Zа-яА-Яёії]+$',
				flags: 'i',
				maxlength: 100
			}
		};

		this.$page = $(this.selectors.page);
	}

	getNodes = () => {
		this.$adresses = this.$page.find(this.selectors.adresses);
		this.$tmpl = _.template(_.unescape(this.$page.find(this.selectors.tmpl).html().trim()), this.tmplSyntax);
		this.$submit = this.$page.find(this.selectors.submit);
		this.$form = this.$page.find(this.selectors.form);
	}

	validate = ($form, isCity = false) => {
		const $inputs = $form.find('.js-field-input').not('.js-input-city');
		const $city = $form.find('.js-input-city');
		const $adressInputs = $form.find('.field_type_address').find('input');
		const $addressLast = $adressInputs.slice('-2');
		$inputs.attr('pattern', '^[^ ].*$')
				.attr('flags', 'i');
		$adressInputs.attr('maxlength', 10);
		$addressLast.attr('data-allow-empty', true)
					.attr('required', true);
		if (isCity) {
			$city.data(this.validateInfo.city.data)
				.attr('maxlength', this.validateInfo.city.maxlength)
				.attr('pattern', this.validateInfo.city.pattern)
				.attr('flags', this.validateInfo.city.flags);
		}
	};

	resetHeight = e => {
		const $target = $(e.target);
		const $slideToggle = $target.closest(this.selectors.slideToggle.wrapper);

		if ($slideToggle.length && !isViewport(sm)) {
			$slideToggle.css('height', 'auto');
		}
	}

	renderAdress = (data, index = -1) => {
		const $adress = this.$adresses.find(this.selectors.adress);
		const $node = $(this.$tmpl({adress: data}));
		const $form = $node.find('form');

		switch (index) {
			case -1:
				this.$adresses.append($node);
				break;
			case 0:
				this.$adresses.prepend($node);
				break;
			default:
				$node.insertAfter($adress.eq(index - 1));
		}

		this.validate($form, true);
		$form.csssrValidation();
	}

	deleteAdress = adress => () => adress.remove();

	closeForm = form => {
		const $form = $(form);
		const $slideToggle = $form.closest(this.selectors.slideToggle.el);
		const $slideWrapper = $slideToggle.find(this.selectors.slideToggle.wrapper);

		form.reset();
		$slideToggle.removeClass(this.state.slideToggle.open);
		$slideWrapper.css('height', 0);
	}

	onSubmit = e => {
		e.preventDefault();
		e.stopPropagation();
		const $target = $(e.target);
		const action = $target.data('action');
		const tmplData = $target.serializeObject();
		const $data = $target.serialize();

		switch (action) {
			case 'add':
				saveAdress($data).then(
					() => {
						this.renderAdress(tmplData);
						this.closeForm($target[0]);
					},
					() => console.log('error')
				);
				break;
			case 'change':
				changeAdress($data).then(
					this.onChange($target[0], tmplData),
					() => console.log('error')
				);
				break;
		}
	}

	onChange = (form, data) => () => {
		const $form = $(form);
		const $adress = $form.closest(this.selectors.adress);
		const position = $adress.index();
		$adress.remove();
		this.renderAdress(data, position);
	};

	onDelete = e => {
		const $target = $(e.target);
		const $adress = $target.closest(this.selectors.adress);
		const $form = $adress.find('form');
		const $data = $form.serialize();
		deleteAdress($data).then(
			this.deleteAdress($adress),
			() => console.log('error')
		);
	}

	setChangeState = e => {
		const $target = $(e.target);
		const $adress = $target.closest(this.selectors.adress);
		$adress.addClass(this.state.adress.change);
	}

	setHandlers = () => {
		const selectors = this.selectors;
		this.$page.on('submit', selectors.form, this.onSubmit);
		this.$page.on('click', selectors.controls.change, this.setChangeState);
		this.$page.on('click', selectors.controls.delete, this.onDelete);
		this.$submit.on('click', this.resetHeight);
	}

	render = () => {
		if (this.$page.length) {
			this.getNodes();
			this.setHandlers();
			this.$form.each((i, form) => this.validate($(form)));
		}
	}
}



/** WEBPACK FOOTER **
 ** ./app/blocks/pa-my-address/pa-my-adress.js
 **/